angular
  .module("pe4h")
  .controller("PostProject", function (
    $scope,
    $state,
    $http,
    $q,
    configuration,
    AuthService,
    Upload,
    $uibModal,
    fbqService
  ) {

    // Validations
    $scope.validateStep = function (step) {
      switch (step) {
        case 1:
          return $scope.wizardData.firstname && $scope.wizardData.lastname;
        case 2:
          return $scope.wizardData.engType != null;
        case 3:
          return $scope.wizardData.email && $scope.wizardData.email != "" && !$scope.email_isEngineer;
        case 4:
          return $scope.wizardData.projectDetails != null;
        case 5:
          return $scope.wizardData.zipCode != null && $scope.wizardData.city != null && $scope.wizardData.state != null;
        case 6:
          // If the user selected a custom date, we need to validate the completed_by_date field
          if ($scope.wizardData.completed_by == $scope.completed_by_options[3]) {
            return $scope.wizardData.completed_by_date != null;
          }
          return $scope.wizardData.completed_by != null;
        case 7:
          return $scope.wizardData.project_name != null;
        default:
          return true;
      }
    };

    // Function to calculate the progress bar completition
    $scope.progress = function () {
      var increment = 100 / $scope.totalSteps;
      return $scope.currentStep * increment;
    };

    $scope.forgotPassword = function() {
      $scope.showForgotPasswordModal();
      $http({
          url: configuration.webApi.auth.reset_password,
          method: "POST",
          data: {
              "Email": $scope.wizardData.email
          },
      }).success(function(res, status, headers, config) {
          console.log(res);

      }).error(function(error, status, headers, config) {
          $scope.alertErrorFromServer(error);
          //authFactory.logout();
      });
  }

    // Next button
    $scope.nextStep = function () {
      // If it's the final step
      if ($scope.currentStep == 7) {
        // If the email already exists but the user is not logged in, go to the password form
        if ($scope.email_isClient) {
          $scope.currentStep = $scope.currentStep + 1;
        }

        // if the client is already logged in
        if ($scope.isClient) {
          $scope.first_project = false;
          $scope.createProject();
        }

        // If he/she is a new user, create the user and the project
        if ($scope.email_isNew) {
          $scope.first_project = true;
          console.log($scope.wizardData);
          $scope.postFirstProject();
        }
      } else {
        $scope.currentStep = $scope.currentStep + 1;
        if ($scope.currentStep == 3 && $scope.isClient) {
          $scope.currentStep = 4;
        }
        $scope.currentProgress = $scope.progress($scope.currentStep);
      }
    };

    // Back button
    $scope.previousStep = function () {
      $scope.currentStep = $scope.currentStep - 1;
      if ($scope.currentStep == 3 && $scope.isClient) {
        $scope.currentStep = 2;
      }
      $scope.currentProgress = $scope.progress($scope.currentStep);
    };

    $scope.popup = {
      opened: false
    };

    $scope.updateCharLeft = function () {
      if ($scope.description != undefined)
        $scope.charLeft = 2000 - $scope.description.length;
    };

    $scope.open = function () {
      $scope.popup.opened = true;
    };

    $scope.openZoho = function(){
      $zoho.salesiq.floatwindow.visible('show');
    }

    $scope.getZipInfo = function () {
    if ($scope.wizardData.zipCode.length == 5) {
      $http({
        url: configuration.webApi.zipcodes.exists({
          code: $scope.wizardData.zipCode
        }),
        method: "GET"
      })
        .success(function (res) {
          if (res) {
            $scope.wizardData.city = res.City.toLowerCase().replace(
              /\b\w/g,
              function (l) {
                return l.toUpperCase();
              }
            );
            $scope.wizardData.state = res.State;
          }
        })
        .error(function (error) {
          $scope.alertErrorFromServer(error);
        });
      }
    };

    // Function to check the email on step 3.
    $scope.userExists = function (email) {
      $http({
        url: configuration.webApi.users.exists_detailed,
        method: "POST",
        data: {
          Email: email
        }
      }).success(function (res) {
        if (res) {
          if (res && res.IsClient) {
            $scope.email_isClient = true;
            $scope.email_isEngineer = false;
            $scope.email_isNew = false;
          }
          if (res && res.IsProfessional) {
            $scope.email_isClient = false;
            $scope.email_isEngineer = true;
            $scope.email_isNew = false;
            $scope.showEmailAddressError()
          }
        } else {
          $scope.email_isClient = false;
          $scope.email_isEngineer = false;
          $scope.email_isNew = true;
        }
      }).error(function (error) {
        $scope.alertErrorFromServer(error);
      });
    }

    // Function to post the first project. First, It will create the client
    $scope.postFirstProject = function () {
      $http({
        url: configuration.webApi.users.client,
        method: "POST",
        data: {
          Email: $scope.wizardData.email,
          FirstName: $scope.wizardData.firstname,
          LastName: $scope.wizardData.lastname
        }
      })
        .success(function (res) {
          var new_token = res.Token;
          AuthService.save(new_token);
          $scope.loadUser(res.User);
          $scope.createProject();
        })
        .error(function (error) {
          $scope.alertErrorFromServer(error);
        });

    };

    $scope.showEmailAddressError = function () {
      $uibModal.open({
        templateUrl: "modal-professional-email.html"
      });
    };

    $scope.showForgotPasswordModal = function () {
      $uibModal.open({
        templateUrl: "modal-forgot-password.html",
        scope: $scope
      });
    };

    // Function to create the project and login the client on step 8.
    $scope.login = function () {
      $http({
        url: configuration.webApi.auth.login,
        method: "POST",
        data: {
          Email: $scope.wizardData.email,
          Password: $scope.wizardData.password
        },
        skipInterceptors: true
      })
        .success(function (res, status, headers, config) {
          var new_token = res.Token;
          $scope.loadUser(res.User);
          AuthService.save(new_token);
          $scope.createProject();
          $scope.goToHome();
        })
        .error(function (error, status, headers, config) {
          $scope.alertErrorFromServer(error);
        });
    };

    $scope.createProject = function () {
      uploadProject().then(function (data) {
        fbqService.fbq("track", "Lead", { content_name: "Post Project" });
        $scope.projectCreated = data.data;
        // Redirect the user to the last step
        $scope.currentStep = 9;
      });
    };

    $scope.goToHome = function () {
      if ($scope.first_project) {
        $state.go("projects", { first: true });
      } else {
        $state.go("project", { uid: $scope.projectCreated.UID });
      }
    }

    $scope.removeFile = function () {
      $scope.file = undefined;
    };

    // Datepicker

    $scope.datepicker = [];
    var today = new Date();
    var minDate = new Date();
    minDate.setDate(today.getDate() + 5);
    $scope.datepicker.options = {
      showWeeks: false,
      minDate: minDate
    };

    function createDateAsUTC(date) {
      return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
    }
  
    var uploadProject = function () {
      var deferred = $q.defer();
      // If the user passes a custom completed by date, set to the end of the day
      if($scope.wizardData.completed_by_date){
        $scope.wizardData.completed_by_date.setHours(23);
        $scope.wizardData.completed_by_date.setMinutes(59);
        $scope.wizardData.completed_by_date.setSeconds(59);
      }
      Upload.upload({
        url: configuration.webApi.projects.projects,
        data: {
          LicenseId: $scope.wizardData.engType.Id,
          Zip: $scope.wizardData.zipCode,
          Address: $scope.wizardData.address,
          Title: $scope.wizardData.project_name,
          Description: $scope.wizardData.projectDetails,
          WorkCompletedBy: $scope.wizardData.completed_by.value,
          //createDateAsUTC change date to UTC, in server side date would be saved completed_by_date in +00:00 GMT at 23:59:59
          //This is needed because before a date saved at -3:00 GTM would be transformed to day after in backend at 02:59:59 +00:00
          WorkCompletedDate: $scope.wizardData.completed_by.value == 3 ? moment(createDateAsUTC($scope.wizardData.completed_by_date)).toDate() : null,
          Attachment: $scope.file
        }
      }).then(
        function (data) {
          deferred.resolve(data);
        },
        function (data) {
          $scope.alertErrorFromServer(data);
          deferred.reject(data);
        },

        //progress callback
        function (evt) {
          deferred.notify({
            prog: evt.loaded / evt.total,
            evt: evt
          });
        }
      );

      return deferred.promise;
    };

    // Completed by options for step 6
    $scope.completed_by_options = [
      { text: "Within a week", value: 0 },
      { text: "In the next 2-3 weeks", value: 1 },
      { text: "In a month or longer", value: 2 },
      { text: "Choose a date", value: 3 }
    ];

    function init() {
      // Variable initializations
      $scope.charLeft = 2000;
      $scope.onSite = false;
      $scope.public = false;
      $scope.totalSteps = 7;
      $scope.zipcode = $state.params.zip;
      $scope.eType = $scope.getLicenseFromId($state.params.type);
      $scope.projectCreated = null;
      $scope.first_project = false;

      // Email related data
      $scope.email_isClient = false;
      $scope.email_isEngineer = false;
      $scope.email_isNew = false;

      // Wizard
      $scope.wizardData = {};
      $scope.isClient = false;
      if ($scope.user) {
        $scope.isClient = $scope.user.IsClient;
        $scope.email_isClient = true;
      }

      // If the user is client, start from step 2 and prefill firstname and lastname.
      // If the user is an Eng, do nothing, the user will be automatically redirected to the Homepage
      // (See $stateChangeStart on root-controller.js)
      if ($scope.isClient) {
        $scope.currentStep = 2;
        $scope.wizardData.email = $scope.user.Email;
        $scope.wizardData.firstname = $scope.user.FirstName;
        $scope.wizardData.lastname = $scope.user.LastName;
      } else {
        $scope.currentStep = 1;
      }

      // Calculte current progress
      $scope.currentProgress = $scope.progress();
    }

    init();
  });
